import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { closeNotification, displayNotification, handleNotification } from 'notification/actions';
import NotificationContainer from 'notification/NotificationContainer';

const NotificationApp = connect(
  (state) => ({
    listOfNotifications: state?.notification?.listOfNotifications,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        displayNotification,
        closeNotification,
        handleNotification,
      },
      dispatch,
    ),
)(NotificationContainer);

export default NotificationApp;
